var map = {
	"./ar.png": 23341,
	"./de.png": 22553,
	"./en.png": 20749,
	"./es.png": 64894,
	"./fa.png": 61633,
	"./fr.png": 99871,
	"./ru.png": 28544,
	"./tr.png": 91797,
	"./zh.png": 90297
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87537;